import { useCallback, useState } from 'react';
import { PET_DEMOS_STEPS } from '../petDemographics.constants';

const usePetDemosSteps = () => {
  const [currentStep, setCurrentStep] = useState(PET_DEMOS_STEPS.WELCOME);

  const goToNextStep = useCallback(() => {
    // TODO: validations for going to next step
    setCurrentStep((prevStep) => prevStep + 1);
  }, [setCurrentStep]);

  const goToPreviousStep = useCallback(() => {
    // TODO: validations for going to prev step
    setCurrentStep((prevStep) => prevStep - 1);
  }, [setCurrentStep]);

  return {
    currentStep,
    goToNextStep,
    goToPreviousStep,
    initialStep: currentStep === PET_DEMOS_STEPS.WELCOME,
  };
};

export { usePetDemosSteps };
